// ============================================================================
// BEHAVIORS - Unica fonte di verità per il behavior-loader
// ============================================================================
// `import.meta.glob` è una feature nativa di Vite:
//  - BUILD TIME: analizzato staticamente → ogni file diventa un chunk hashato
//  - RUNTIME:    restituisce { './path.js': () => import('./path.js') }
// Per aggiungere un behavior basta creare il file e aggiornare la lista.
// Alias → path dei moduli caricati dinamicamente tramite data-behavior.
// I moduli global/* sono wrapper di init per moduli caricati staticamente
// in main.js — vengono triggerati da application.html.haml su ogni pagina.
// ============================================================================

export const behaviors = {
  // Global - Moduli inizializzati su ogni pagina tramite application.html.haml
  'global/globalScope': import.meta.glob('./global/globalScope.js'),
  'global/disableAfterSave': import.meta.glob('./global/disableAfterSave.js'),
  'global/clearUtmSource': import.meta.glob('./global/clearUtmSource.js'),
  'global/multipleTabSync': import.meta.glob('./global/multipleTabSync.js'),
  'global/jobSupervisor': import.meta.glob('./global/jobSupervisor.js'),
  'global/createSelect2': import.meta.glob('./global/createSelect2.js'),
  'global/formChanges': import.meta.glob('./global/formChanges.js'),
  // Business Units
  'views/business_units/edit': import.meta.glob('./views/business_units/edit.js'),
  'views/business_units/get_uscita_temp': import.meta.glob('./views/business_units/get_uscita_temp.js'),
  // CP1s
  'views/cp1s/index': import.meta.glob('./views/cp1s/index.js'),
  // Far As
  'views/far_as/index': import.meta.glob('./views/far_as/index.js'),
  // Guest Presences
  'views/guest_presences/index': import.meta.glob('./views/guest_presences/index.js'),
  // Guest Events
  'views/guest_events/form': import.meta.glob('./views/guest_events/form.js'),
  'views/guest_events/calcIpr': import.meta.glob('./views/guest_events/calcIpr.js'),
  // Mails
  'views/mails/new': import.meta.glob('./views/mails/new.js'),
  // Domestics
  'views/domestics/agenda': import.meta.glob('./views/domestics/agenda.js'),
  'views/domestics/modal_for_agenda': import.meta.glob('./views/domestics/modal_for_agenda.js'),
  'views/domestics/siat_piani': import.meta.glob('./views/domestics/siat_piani.js'),
  'views/domestics/smartlea_validation': import.meta.glob('./views/domestics/smartlea_validation.js'),
  'views/domestics/paghe_dolce_modal': import.meta.glob('./views/domestics/paghe_dolce_modal.js'),
  'views/domestics/activities_registration': import.meta.glob('./views/domestics/activities_registration.js'),
  'views/domestics/calendar': import.meta.glob('./views/domestics/calendar.js'),
  'views/domestics/calendar_form_modal': import.meta.glob('./views/domestics/calendar_form_modal.js'),
  'views/domestics/adi_sgdt_dom': import.meta.glob('./views/domestics/adi_sgdt_dom.js'),
  'views/domestics/reload_agenda': import.meta.glob('./views/domestics/reload_agenda.js'),
  'views/domestics/sub_activities_config': import.meta.glob('./views/domestics/sub_activities_config.js'),
  // Guest Drugs
  'views/guest_drugs/profile_therapies_modal': import.meta.glob('./views/guest_drugs/profile_therapies_modal.js'),
  'views/guest_drugs/form': import.meta.glob('./views/guest_drugs/form.js'),
  // Parameters Configs
  'views/parameters_configs/parameters_partial/h2oIntegration': import.meta.glob(
    './views/parameters_configs/parameters_partial/h2oIntegration.js',
  ),
  'views/parameters_configs/parameters_partial/domiciliare': import.meta.glob(
    './views/parameters_configs/parameters_partial/domiciliare.js',
  ),
  'views/parameters_configs/parameters_partial/parameters': import.meta.glob('./views/parameters_configs/parameters_partial/parameters.js'),
  // Guest Exams
  'views/guest_exams/index': import.meta.glob('./views/guest_exams/index.js'),
  // Guest Valutations
  'views/guest_valutations/new': import.meta.glob('./views/guest_valutations/new.js'),
  'views/guest_valutations/adi_sgdt': import.meta.glob('./views/guest_valutations/adi_sgdt.js'),
  'views/guest_valutations/allergieNonRiferite': import.meta.glob('./views/guest_valutations/allergieNonRiferite.js'),
  'views/guest_valutations/validationRangeAndUserModal': import.meta.glob('./views/guest_valutations/validationRangeAndUserModal.js'),
  'views/guest_valutations/valutationPrintUpdate': import.meta.glob('./views/guest_valutations/valutationPrintUpdate.js'),
  // Guest Needs
  'views/guest_needs/area_select_for_guest_needs': import.meta.glob('./views/guest_needs/area_select_for_guest_needs.js'),
  // PAI
  'views/pai/area_select_for_desease_and_target': import.meta.glob('./views/pai/area_select_for_desease_and_target.js'),
  // Deadlines
  'views/deadlines/calendar': import.meta.glob('./views/deadlines/calendar.js'),
  // Guest
  'views/guest/guestValidation': import.meta.glob('./views/guest/guestValidation.js'),
  'views/guest/guestFormSubmit': import.meta.glob('./views/guest/guestFormSubmit.js'),
  'views/guest/guest': import.meta.glob('./views/guest/guest.js'),
  'views/guest/patologiesFilters': import.meta.glob('./views/guest/patologiesFilters.js'),
  // Guest VMDs
  'views/guest_vmds/new': import.meta.glob('./views/guest_vmds/new.js'),
  // Measurements
  'views/measurements/form': import.meta.glob('./views/measurements/form.js'),
  // SIAD1s
  'views/siad1s/siadDataFineCura': import.meta.glob('./views/siad1s/siadDataFineCura.js'),
  // RIAFAM2s
  'views/riafam2s/calcPosizioneTicket': import.meta.glob('./views/riafam2s/calcPosizioneTicket.js'),
  // Menu Reports
  'views/menu_reports/gdpr_reports': import.meta.glob('./views/menu_reports/gdpr_reports.js'),
  'views/menu_reports/cot_reports': import.meta.glob('./views/menu_reports/cot_reports.js'),
  // Activity
  'views/activity/activity': import.meta.glob('./views/activity/activity.js'),
  // Parameters
  'views/parameters/labels_select_vmd': import.meta.glob('./views/parameters/labels_select_vmd.js'),
  // Browser
  'views/browser/fascicolo_visualizzatore': import.meta.glob('./views/browser/fascicolo_visualizzatore.js'),
  // User
  'views/user/userFormSubmit': import.meta.glob('./views/user/userFormSubmit.js'),
  // Guest Protections
  'views/guest_protections/guest_protection': import.meta.glob('./views/guest_protections/guest_protection.js'),
  // Components
  'components/guest_tab': import.meta.glob('./components/guest_tab.js'),
  'components/bu_schema': import.meta.glob('./components/bu_schema.js'),
  'components/vcog': import.meta.glob('./components/vcog.js'),
  'components/rsaa_importo_valutazione': import.meta.glob('./components/rsaa_importo_valutazione.js'),
  'components/input_dates_csv_cp_report': import.meta.glob('./components/input_dates_csv_cp_report.js'),
  'components/cf_normalization': import.meta.glob('./components/cf_normalization.js'),
  'components/get_single_vmd_chart': import.meta.glob('./components/get_single_vmd_chart.js'),
  'components/prompt_two_factor_validation': import.meta.glob('./components/prompt_two_factor_validation.js'),
  'components/ldap_username_validation': import.meta.glob('./components/ldap_username_validation.js'),
  'components/print_fluid_balance_report': import.meta.glob('./components/print_fluid_balance_report.js'),
  'components/print_diuresis_24h_report': import.meta.glob('./components/print_diuresis_24h_report.js'),
  'components/planning_nr_gads': import.meta.glob('./components/planning_nr_gads.js'),
  'components/handle_hour_management': import.meta.glob('./components/handle_hour_management.js'),
  'components/nr_cartella': import.meta.glob('./components/nr_cartella.js'),
  'components/select_class_toggler': import.meta.glob('./components/select_class_toggler.js'),
  'components/mirror_input': import.meta.glob('./components/mirror_input.js'),
  'components/protection_control': import.meta.glob('./components/protection_control.js'),
  'components/overdose_control': import.meta.glob('./components/overdose_control.js'),
  'components/selection_decodes': import.meta.glob('./components/selection_decodes.js'),
  'components/spot_meal_registration': import.meta.glob('./components/spot_meal_registration.js'),
  'components/domestic_alert_edit_activity': import.meta.glob('./components/domestic_alert_edit_activity.js'),
  'components/check_date_out': import.meta.glob('./components/check_date_out.js'),
  'components/select_guest_business_units_filter': import.meta.glob('./components/select_guest_business_units_filter.js'),
  'components/select2_select_all': import.meta.glob('./components/select2_select_all.js'),
  'components/calc_data_fine': import.meta.glob('./components/calc_data_fine.js'),
  'components/modify_all_gap': import.meta.glob('./components/modify_all_gap.js'),
  'components/documents_popup': import.meta.glob('./components/documents_popup.js'),
  'components/file_preview': import.meta.glob('./components/file_preview.js'),
  'components/store_document': import.meta.glob('./components/store_document.js'),
  'components/open_menu_modals': import.meta.glob('./components/open_menu_modals.js'),
  'components/sticky_title_nav': import.meta.glob('./components/sticky_title_nav.js'),
  'components/rsaa_check_fields': import.meta.glob('./components/rsaa_check_fields.js'),
};
